import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { NotificationsProvider } from '@/context/NotificationsContext';
import { ToastProvider } from '@/context/ToastContext';
import { LiveAlertsProvider } from '@/context/LiveAlertsContext';
import { LaundryProfileProvider } from '@/context/LaundryProfileContext';
import Sidebar, { SidebarContent } from './Sidebar';
import Topbar from './Topbar';

const SIDEBAR_COLLAPSED_KEY = 'lb_sidebar_collapsed';

export default function DashboardLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return window.localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === '1';
    } catch {
      return false;
    }
  });
  const location = useLocation();

  const toggleCollapse = () => {
    setCollapsed((value) => {
      const next = !value;
      try {
        window.localStorage.setItem(SIDEBAR_COLLAPSED_KEY, next ? '1' : '0');
      } catch {
        // ignore storage errors
      }
      return next;
    });
  };

  return (
    <ToastProvider>
      <NotificationsProvider>
        <LaundryProfileProvider>
          <LiveAlertsProvider>
            <div className="relative min-h-screen bg-background-100">
              {/* decorative colour field that the glass surfaces frost over */}
              <div className="lb-app-glow pointer-events-none fixed inset-0 z-0" aria-hidden="true" />

              <div className="relative z-10 flex min-h-screen">
                <Sidebar collapsed={collapsed} onToggleCollapse={toggleCollapse} />

                <div className="flex min-w-0 flex-1 flex-col">
                  <Topbar onOpenMenu={() => setMobileOpen(true)} />
                  <main className="flex-1 px-4 py-5 md:px-6 md:py-6">
                    <div key={location.pathname} className="mx-auto w-full max-w-[1280px] animate-page-in">
                      <Outlet />
                    </div>
                  </main>
                </div>
              </div>

              {mobileOpen ? (
                <div className="fixed inset-0 z-50 lg:hidden">
                  <div
                    className="absolute inset-0 bg-foreground-950/45 animate-fade-in"
                    onClick={() => setMobileOpen(false)}
                    aria-hidden="true"
                  />
                  <div className="lb-drawer absolute inset-y-0 start-0 w-[320px] max-w-[88vw] border-e border-background-200/70 shadow-pop">
                    <SidebarContent onNavigate={() => setMobileOpen(false)} />
                  </div>
                </div>
              ) : null}
            </div>
          </LiveAlertsProvider>
        </LaundryProfileProvider>
      </NotificationsProvider>
    </ToastProvider>
  );
}